import { Tabs, Tab } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import MembersTable from "./MembersTable";
import OrganizationApiKeysPage from "./OrganizationApiKeysPage";
import OrganizationTrainDefaultsPage from "./OrganizationTrainDefaultsPage";
import ReassignDatasetPanel from "./ReassignDatasetPanel";
import { buttonText } from "../../../utils/buttonText";

function AdminOrganization(props) {
  const { fetchUsersData, usersData } = props;
  const [priorities, setPriorities] = useState({});

  // 获取所有组织的优先级
  const fetchPriorities = async () => {
    try {
      const response = await axios.get("/auth/organization/priorities");
      setPriorities(response.data);
    } catch (error) {
      console.error("Failed to fetch priorities:", error);
    }
  };

  useEffect(() => {
    fetchPriorities();
  }, []);

  const organizationNames = usersData ? Object.keys(usersData) : [];

  return (
    <div className="admin-organization-shell">
      <Tabs className="admin-organization-tabs">
        <Tab eventKey="reassign-dataset" title={buttonText("Reassign Dataset")}>
          <ReassignDatasetPanel organizationNames={organizationNames} />
        </Tab>
        {usersData &&
          Object.entries(usersData)
            .sort(([nameA], [nameB]) => {
              // Preserve the public branch ordering: larger values appear first.
              const priorityA = priorities[nameA] || 5;
              const priorityB = priorities[nameB] || 5;
              return priorityB - priorityA;
            })
            .map(([organizationName, users]) => {
              const priority = priorities[organizationName] || 5;
              return (
                <Tab
                  key={organizationName}
                  eventKey={organizationName}
                  title={`${organizationName} (P${priority})`}
                >
                  <Tabs className="admin-organization-subtabs mt-3">
                    <Tab eventKey="members" title={buttonText("Members")}>
                      <MembersTable
                        members={users}
                        organizationName={organizationName}
                        fetchUsersData={fetchUsersData}
                        priority={priority}
                        fetchPriorities={fetchPriorities}
                      />
                    </Tab>
                    <Tab eventKey="api-keys" title={buttonText("API Keys")}>
                      <OrganizationApiKeysPage
                        organizationName={organizationName}
                      />
                    </Tab>
                    <Tab eventKey="training-defaults" title={buttonText("Training Defaults")}>
                      <OrganizationTrainDefaultsPage
                        organizationName={organizationName}
                      />
                    </Tab>
                  </Tabs>
                </Tab>
              );
            })}
      </Tabs>
    </div>
  );
}

export default AdminOrganization;
